'use strict';

var _ = require('lodash');
var FaresBasisGroupsTransformerFactory = function FaresBasisGroupsTransformerFactory(DataTransformer) {
  function FaresBasisGroupsTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'fares-basis-groups-mode';
    this.priority = 1;
  }
  FaresBasisGroupsTransformer.prototype = Object.create(DataTransformer.prototype);
  FaresBasisGroupsTransformer.constructor = FaresBasisGroupsTransformer;
  FaresBasisGroupsTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  FaresBasisGroupsTransformer.prototype.isCacheable = function () {
    return false;
  };
  FaresBasisGroupsTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  FaresBasisGroupsTransformer.prototype.transform = function (data) {
    var groups = _.get(data, 'domain.results', []);
    var results = [];
    for (var i = 0; groups.length > i; i++) {
      var group = groups[i];
      var item = {
        comments: group.comments,
        fareBasisCodeMapping: group.fareBasisCodeMapping,
        fareBasisGroup: group.fareBasisGroup,
        journeyType: group.journeyType,
        marketOrigin: group.marketOrigin || '',
        marketDestination: group.marketDestination || '',
        operatingCarrier: group.operatingCarrier,
        priority: group.priority,
        useForAveraging: transformBooleanToYesNo(group.useForAveraging)
      };
      if (group.marketOrigin) {
        item.market = group.marketOrigin + '-' + group.marketDestination;
      }
      results.push(item);
    }
    return results;
  };
  return FaresBasisGroupsTransformer;
};
function transformBooleanToYesNo(value) {
  return value ? 'Yes' : 'No';
}
FaresBasisGroupsTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = FaresBasisGroupsTransformerFactory;